import { render, staticRenderFns } from "./Fee.vue?vue&type=template&id=0f15d0ff&scoped=true&"
import script from "./Fee.vue?vue&type=script&lang=js&"
export * from "./Fee.vue?vue&type=script&lang=js&"
import style0 from "./Fee.vue?vue&type=style&index=0&id=0f15d0ff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f15d0ff",
  null
  
)

export default component.exports